/**
 * Decimal odds as American, e.g. 2.60 -> "+160", 1.52 -> "-192".
 *
 * Shared so the Premier League and NFL modals cannot drift apart on the
 * conversion. Both display the decimal price with this underneath.
 */
export function toAmericanOdds(decimal) {
  if (decimal == null) return null;
  if (decimal >= 2.0) return `+${Math.round((decimal - 1) * 100)}`;
  return `${Math.round(-100 / (decimal - 1))}`;
}
